var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "updateProductUseTimeDiglog",
          attrs: {
            visible: _vm.addUseTimeBox,
            width: "60%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addUseTimeBox = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "tableTitle",
              staticStyle: { display: "flex", "align-items": "center" },
            },
            [
              _c(
                "span",
                { staticClass: "label", staticStyle: { width: "1.7rem" } },
                [_vm._v("日期")]
              ),
              _c(
                "span",
                { staticClass: "label", staticStyle: { width: "0.6rem" } },
                [_vm._v("带出显示")]
              ),
              _c(
                "span",
                { staticClass: "label", staticStyle: { width: "2rem" } },
                [_vm._v("产品名称")]
              ),
              _c(
                "span",
                { staticClass: "label", staticStyle: { width: "2.08rem" } },
                [_vm._v("按时间维护")]
              ),
              _c(
                "span",
                { staticClass: "label", staticStyle: { width: "0.5rem" } },
                [_vm._v("操作")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "100px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.optimizeItinerary },
                },
                [_vm._v("AI优化行程")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { position: "absolute" } },
            _vm._l(_vm.checkBudgetDetail.planDayList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "dayQuan",
                  style:
                    item.planDay == _vm.checkPlanDay
                      ? "background: #da4e1a;color: #fff;"
                      : "",
                  on: {
                    click: function ($event) {
                      return _vm.goToDay(item.planDay)
                    },
                  },
                },
                [_vm._v("D" + _vm._s(item.planDay))]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              style:
                "display: flex;overflow-y: scroll;margin-left: 0.4rem;height:" +
                _vm.height +
                "px",
            },
            [
              _c(
                "div",
                _vm._l(
                  _vm.checkBudgetDetail.planDayList,
                  function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "daybox",
                        style:
                          item.planDay == _vm.checkPlanDay
                            ? "box-shadow: 0px 1px 10px 2px rgba(0, 0, 0, 0.4);"
                            : "",
                        attrs: { id: "changeTimeDay" + item.planDay },
                        on: {
                          mouseover: function ($event) {
                            _vm.checkPlanDay = item.planDay
                          },
                        },
                      },
                      [
                        _c("div", { staticStyle: { width: "1.7rem" } }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(_vm.dateFormatYMD(item.planDate, ".")) +
                                " "
                            ),
                          ]),
                          _c(
                            "label",
                            _vm._l(item.cityList, function (item1, index1) {
                              return _c("span", { key: index1 }, [
                                _vm._v(_vm._s(item1.cityName) + " "),
                                index1 != item.cityList.length - 1
                                  ? _c("span", [_vm._v("-")])
                                  : _vm._e(),
                              ])
                            }),
                            0
                          ),
                          _c("p", { staticStyle: { "margin-top": "5px" } }, [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.addDesc(item)
                                  },
                                },
                              },
                              [_vm._v("添加当日文字描述")]
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "draggable",
                              {
                                attrs: { animation: "300" },
                                on: {
                                  end: function ($event) {
                                    return _vm.draggerEnd($event, item)
                                  },
                                },
                                model: {
                                  value: item.budgetChangeTimeData,
                                  callback: function ($$v) {
                                    _vm.$set(item, "budgetChangeTimeData", $$v)
                                  },
                                  expression: "item.budgetChangeTimeData",
                                },
                              },
                              [
                                _c(
                                  "transition-group",
                                  _vm._l(
                                    item.budgetChangeTimeData,
                                    function (item1, index1) {
                                      return _c(
                                        "div",
                                        {
                                          key: index + "-" + index1,
                                          staticClass: "productBox",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "0.2rem" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("el-checkbox", {
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeData(
                                                          item1
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: item1.checkFlag,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item1,
                                                          "checkFlag",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item1.checkFlag",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone textspan",
                                              staticStyle: { width: "2rem" },
                                            },
                                            [
                                              item1.state != 11
                                                ? _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item1.resourceNameCn ==
                                                            ""
                                                            ? item1.resourceNameEn
                                                            : item1.resourceNameCn
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder:
                                                            "请输入标题",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeData(
                                                              item1
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            item1.resourceNameCn,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item1,
                                                              "resourceNameCn",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item1.resourceNameCn",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone datespan",
                                              staticStyle: { width: "2.08rem" },
                                            },
                                            [
                                              _c("el-time-select", {
                                                attrs: {
                                                  placeholder: "起始时间",
                                                  clearable: "",
                                                  size: "mini",
                                                  "picker-options": {
                                                    start: "00:00",
                                                    step: "00:15",
                                                    end: "23:59",
                                                    minTime:
                                                      index1 != 0
                                                        ? item
                                                            .budgetChangeTimeData[
                                                            index1 - 1
                                                          ].budgetEndTime
                                                        : "",
                                                  },
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeData(item1)
                                                  },
                                                },
                                                model: {
                                                  value: item1.budgetStartTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item1,
                                                      "budgetStartTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item1.budgetStartTime",
                                                },
                                              }),
                                              _vm._v("  "),
                                              _c("el-time-select", {
                                                attrs: {
                                                  placeholder: "结束时间",
                                                  clearable: "",
                                                  size: "mini",
                                                  "picker-options": {
                                                    start: "00:00",
                                                    step: "00:15",
                                                    end: "23:59",
                                                    minTime:
                                                      item1.budgetStartTime,
                                                  },
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.changeData(item1)
                                                  },
                                                },
                                                model: {
                                                  value: item1.budgetEndTime,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item1,
                                                      "budgetEndTime",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item1.budgetEndTime",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "labelone",
                                              staticStyle: {
                                                width: "4rem",
                                                display: "flex",
                                              },
                                            },
                                            [
                                              item1.remark != ""
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "remarkSpan",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openTextDialog(
                                                            item1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item1.remark)
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        "padding-right": "10px",
                                                        width: "3.6rem",
                                                        display: "inline-block",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-link",
                                                        {
                                                          attrs: {
                                                            type: "success",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openTextDialog(
                                                                item1
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("维护文字描述")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                              item1.state == 11
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticStyle: {
                                                        width: "40px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleDelete(
                                                            index1,
                                                            item1,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 删除")]
                                                  )
                                                : _vm._e(),
                                              item1.state == 11
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticStyle: {
                                                        width: "40px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyText(
                                                            item1,
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 复制")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                "justify-content": "center",
                display: "flex",
                padding: "0.1rem",
              },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "savebuttom",
                      on: { click: _vm.addUseTime },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "savebuttom",
                      staticStyle: { "margin-left": "75px" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("关闭")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "savebuttom",
                      staticStyle: { "margin-left": "75px" },
                      on: { click: _vm.deleteAllTime },
                    },
                    [_vm._v("删除所有时间")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.copyToOtherDay, width: "12%" },
          on: {
            "update:visible": function ($event) {
              _vm.copyToOtherDay = $event
            },
          },
        },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.checkDayList,
                callback: function ($$v) {
                  _vm.checkDayList = $$v
                },
                expression: "checkDayList",
              },
            },
            _vm._l(_vm.checkBudgetDetail.planDayList, function (item, index) {
              return _c(
                "div",
                { key: index },
                [
                  item.planDay != _vm.checkObj.day
                    ? _c("el-checkbox", { attrs: { label: item.planDay } }, [
                        _vm._v("D" + _vm._s(item.planDay)),
                      ])
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.copyToOtherDay = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sureCopy } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.textEditDialog, width: "40%" },
          on: {
            "update:visible": function ($event) {
              _vm.textEditDialog = $event
            },
          },
        },
        [
          _c("el-input", {
            staticStyle: { "margin-top": "0.3rem" },
            attrs: {
              type: "textarea",
              placeholder: "请输入内容",
              autosize: "",
            },
            model: {
              value: _vm.textEdit,
              callback: function ($$v) {
                _vm.textEdit = $$v
              },
              expression: "textEdit",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.textEditDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.textSure } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DialogMobileChat", { ref: "DialogMobileChat" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }